module.exports = __webpack_public_path__ + "img/eastcool.37733eb.png";